<div class="container" style="margin-bottom: 100px;">
    <app-year-term-input (childEvent)="getCurList($event)"></app-year-term-input>
    <app-cur-class id="cur-class" [curList]="data" [functionType]="functionType"></app-cur-class>
    <app-cur-class-rwd id="cur-class-rwd" [curList]="data" [functionType]="functionType"></app-cur-class-rwd>
</div>